import momentJalaali from 'moment-jalaali';
import momentGregorian from 'moment';
import { DateObject } from 'react-multi-date-picker';
import gregorian from 'react-date-object/calendars/gregorian';
import gregorianEn from 'react-date-object/locales/gregorian_en';
import { timeDurationTools } from './timeDurationTools';
import {
  mapCalendarToCalendars,
  mapCalendarToLocales,
  mapLanguageToCalendar,
} from './mapCalendar';
import { getEnv } from './getEnv';
import { magicNumbers } from './magicNumbers';

const floorTimeTo30MinutesInterval = (options) =>
  new DateObject(options).minute > 30
    ? new DateObject(options).setMinute(30).setSecond(0)
    : new DateObject(options).setMinute(0).setSecond(0);

const mapDurationToMonth = {
  '1m': 1,
  '3m': 3,
  '6m': 6,
  '12m': 12,
};

export const getTimestamp = (dateTime) => {
  return momentGregorian(dateTime).unix();
};

export const getRequestTimeDuration = (currentDate) => {
  const date = timeDurationTools(currentDate.timeDuration);
  if (date.from && date.to) {
    return getTimestamp(date.to.toDate()) - getTimestamp(date.from.toDate());
  }
};

export const timestampToDateObject = (timestamp) => {
  return new DateObject(
    timestamp * magicNumbers.CONVERT_TIMESTAMP_TO_DATE_FACTOR
  );
};

export const getRequestCacheAdaptedDate = (
  currentDate,
  shouldCache = false
) => {
  const dateTimeParams = {};
  const selectedCalendar = mapLanguageToCalendar[getEnv('REACT_APP_LANGUAGE')];
  const options = {
    calendar: mapCalendarToCalendars[selectedCalendar],
    locale: mapCalendarToLocales[selectedCalendar],
  };

  const isOneMonthOrMore = Object.keys(mapDurationToMonth).includes(
    currentDate.timeDuration
  );
  if (shouldCache && isOneMonthOrMore) {
    dateTimeParams.time_duration = undefined;
    dateTimeParams.from = getTimestamp(
      new DateObject(
        floorTimeTo30MinutesInterval(options).subtract(
          mapDurationToMonth[currentDate.timeDuration],
          'months'
        )
      )
        .convert(gregorian, gregorianEn)
        .format('YYYY-MM-DD HH:mm')
    );
    dateTimeParams.to = getTimestamp(
      new DateObject(floorTimeTo30MinutesInterval(options))
        .convert(gregorian, gregorianEn)
        .format('YYYY-MM-DD HH:mm')
    );
  } else if (currentDate.timeDuration) {
    dateTimeParams.from = undefined;
    dateTimeParams.to = undefined;
    dateTimeParams.time_duration = getRequestTimeDuration(currentDate);
  } else {
    dateTimeParams.time_duration = undefined;
    dateTimeParams.from = currentDate?.fromDate;
    dateTimeParams.to = currentDate?.toDate;
  }

  return dateTimeParams;
};

export const timestampToDateTime = (timestamp) => {
  return momentGregorian.unix(timestamp);
};

const getDateTime = (dateTime, type) => {
  const selectedCalendar = mapLanguageToCalendar[getEnv('REACT_APP_LANGUAGE')];
  let moment = momentJalaali;
  let format = 'jYYYY/jMM/jDD';
  if (selectedCalendar === 'gregorian' || type === 'm') {
    moment = momentGregorian;
    format = 'YYYY-MM-DD';
  }
  let date = null;
  let time = null;
  const timeDuration = moment(dateTime).unix();
  if (dateTime) {
    // تبدیل تاریخ ورودی به شمسی
    date = moment(dateTime).format(format);
    time = moment(dateTime).format('HH:mm');
  } else {
    // تاریخ جاری شمسی
    date = moment().format(format);
    time = moment().format('HH:mm');
  }

  return { date, time, timeDuration };
};

export { getDateTime };
